import { Action } from '../../../types/actions';
import { SET_CARD_SHOW_REPLIES, SET_CARD_REPLY_TEXT } from '../../actions/admin/engage-card-ui';
import { RootState } from '../main';

export type EngageCardUIEntry = { showReplies: boolean; replyText: string };
export type EngageCardUIState = Record<number, EngageCardUIEntry>;

const DEFAULT_ENTRY: EngageCardUIEntry = { showReplies: false, replyText: '' };

export const initialEngageCardUIState: EngageCardUIState = {};

export default function EngageCardUIReducer(
	state: EngageCardUIState = initialEngageCardUIState,
	action: Action
): EngageCardUIState {
	switch (action.type) {
		case SET_CARD_SHOW_REPLIES: {
			const { id, value } = action.payload;
			return { ...state, [id]: { ...(state[id] ?? DEFAULT_ENTRY), showReplies: value } };
		}
		case SET_CARD_REPLY_TEXT: {
			const { id, value } = action.payload;
			return { ...state, [id]: { ...(state[id] ?? DEFAULT_ENTRY), replyText: value } };
		}
		default:
			return state;
	}
}

export const selectEngageCardUI = (state: RootState, id: number): EngageCardUIEntry =>
	state.EngageCardUIReducer?.[id] ?? DEFAULT_ENTRY;
